import React from 'react';

interface ChartContainerProps {
    children: React.ReactNode;
}

const ChartContainer: React.FC<ChartContainerProps> = (props) => {
    const { children } = props;

    return (
        <div
            style={{
                height: '300px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {children}
        </div>
    );
};

export default ChartContainer;
